import React, { useLayoutEffect, useRef } from 'react';
import Picture from './components/Picture.jsx';

const HeroSection = () => {
  const heroRef = useRef(null);
  const iframeRef = useRef(null);

  useLayoutEffect(() => {
    const updateVideoSize = () => {
      const heroEl = heroRef.current;
      const iframeEl = iframeRef.current;

      if (!heroEl || !iframeEl) return;

      const heroWidth = heroEl.offsetWidth;
      const heroHeight = heroEl.offsetHeight;

      if (!heroWidth || !heroHeight) return;

      const videoRatio = 16 / 9; // YouTube player aspect
      const contentRatio = 20 / 9; // Source video content aspect
      const overscan = (contentRatio / videoRatio) * 1.03; // ~1.2875 to crop internal letterbox with small buffer
      const heroRatio = heroWidth / heroHeight;

      let width;
      let height;

      if (heroRatio > videoRatio) {
        width = heroWidth;
        height = heroWidth / videoRatio;
      } else {
        height = heroHeight;
        width = heroHeight * videoRatio;
      }

      // Overscan sufficiently to remove internal letterboxing from 20:9 content inside 16:9 player
      width *= overscan;
      height *= overscan;

      iframeEl.style.width = `${width}px`;
      iframeEl.style.height = `${height}px`;
    };

    updateVideoSize();
    window.addEventListener('resize', updateVideoSize);

    let resizeObserver;

    if (window.ResizeObserver && heroRef.current) {
      resizeObserver = new ResizeObserver(updateVideoSize);
      resizeObserver.observe(heroRef.current);
    }

    return () => {
      window.removeEventListener('resize', updateVideoSize);
      if (resizeObserver && heroRef.current) {
        resizeObserver.unobserve(heroRef.current);
        resizeObserver.disconnect();
      }
    };
  }, []);

  return (
    <div
      ref={heroRef}
      className="relative bg-black overflow-hidden [--hero-height:max(70vh,598px)] sm:[--hero-height:max(var(--vh),598px)] h-[var(--hero-height)] min-h-[598px] max-h-[732.75px]"
      aria-label="Gtechniq Brasil - Hero Section"
    >
      <div className="absolute inset-0" aria-hidden="true">
        <Picture
          src="/images/hero-banner.webp"
          fallbackExt="png"
          alt=""
          pictureClassName="block h-full w-full"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <iframe
          ref={iframeRef}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
          src="https://www.youtube.com/embed/AC2c7p9bjoM?autoplay=1&mute=1&controls=0&rel=0&showinfo=0&modestbranding=1&loop=1&playlist=AC2c7p9bjoM&playsinline=1"
          title="Gtechniq surface protection"
          allow="autoplay; encrypted-media"
          frameBorder="0"
          allowFullScreen={false}
          aria-hidden="true"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/20"></div>

      <div className="relative z-10 flex flex-col items-center justify-start md:justify-center h-[var(--hero-height)] min-h-[598px] max-h-[732.75px] text-white px-6 text-center py-20 md:py-24">
        <div className="max-w-8xl lg:space-y-5 md:space-y-2 max-sm:space-y-2">
          {/* Force 2 lines with explicit line break and uppercase to match brand tone */}
          <h1 className="max-sm:text-[35px] md:text-[45px] lg:text-[50px] xlg:text-[70px] font-bold tracking-[0.02em] md:tracking-[0.04em] leading-tight">
            <span className="block">Revestimentos Profissionais </span>
            
          </h1>

          <p className="max-sm:text-[15px] md:text-[21px] lg:text-[23px] xlg:text-[25px] text-white leading-relaxed max-w-3xl mx-auto">
            Nanocerâmica para a proteção de superfícies automotivas, náuticas e aeronáuticas
          </p>

          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="https://gtechniq.com.br/encontre-um-profissional"
              className="inline-flex min-w-[180px] items-center justify-center px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white transition-all duration-300 bg-[#FF0000] hover:bg-white hover:text-[#FF0000]"
            >
              Onde aplicar
            </a>
            <a
              href="https://gtechniq.com.br/loja"
              className="inline-flex min-w-[180px] items-center justify-center px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white transition-all duration-300 border border-white/70 bg-white/10 hover:bg-white hover:text-[#FF0000]"
            >
              Comprar
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
